import React, {useEffect, useRef, useState} from 'react';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import CloseIcon from '@mui/icons-material/Close';
import './SuperStarDetailsPopup.css'; // Assuming you create some basic CSS styles
import ReactDOM from 'react-dom';
import {useSuperStarInstrumentContext} from "@superstar/context/SuperStarInstrumentContext";

const SuperStarDetailsPopup = ({  closeAllPopups  }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const buttonRef = useRef(null); // Reference for the button
    const { SuperStarInstrument, superStarNameMap, setSuperStarInstruments } = useSuperStarInstrumentContext();

    const togglePopup = () => {
        if (!isPopupOpen && buttonRef.current) {
            // Get the position of the button and calculate the popup position
            const buttonRect = buttonRef.current.getBoundingClientRect();
            setPopupPosition({
                top: buttonRect.bottom + window.scrollY,  // Position it below the button
                left: buttonRect.right + window.scrollX + 10,  // Position it to the right
            });
        }
        setIsPopupOpen(!isPopupOpen);
    };
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsPopupOpen(false);  // Close the current popup when Escape is pressed
                closeAllPopups();       // Call the function to close all popups
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [closeAllPopups]);

    // Define the popup content
    const popupContent = (
        <div className="ss-popup" style={{ top: `${popupPosition.top}px`, left: `${popupPosition.left}px` }}>
            <div className="ss-popup-content">
                {SuperStarInstrument.superStarHoldingsList && SuperStarInstrument.superStarHoldingsList.map((superStar, index) => (
                    <div key={index} className="superstar-column">
                        <div className="superstar-name" style={{ fontWeight: 'bold' }}>
                            {superStar.superStarName}
                        </div>
                        {superStar.holdingLst.map((querterlyHolding, holdingIndex) => (
                            <div key={holdingIndex} className="querterlyHolding-details-popup">
                                <div className="querterlyHolding-qtr-popup">{querterlyHolding.qtr}</div>
                                <div className="querterlyHolding-pct-popup">
                                    {querterlyHolding.holdingPct || 0} %
                                </div>                                <div className="querterlyHolding-change-popup">
                                     {superStar.holding_change_direction_symbol}
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <div className="superstar-details-popup-container">
            {/* Reference the button */}
            <ExpandCircleDownIcon
                ref={buttonRef}
                className="expand-button"
                onClick={togglePopup}
                style={{ cursor: 'pointer', color: '#8C92AC' }}  // Set the color using the color prop
            />
            {isPopupOpen && ReactDOM.createPortal(popupContent, document.body)}
        </div>
    );
};

export default SuperStarDetailsPopup;
